import { ReactElement, useCallback } from 'react';

import { Button, ButtonVariant, TestableComponentProps, useHistoryPushWithBackAction } from '@dreryk/react-components';

import { PrintTemplateClickRegisterAction } from '~libs.desktop.shared.document-template';
import { visitPaths } from '~libs.desktop.shared.paths';

import { consentTemplateActionTranslationKeys, visitTranslationKeys } from '../../../../../../translations';

const t = consentTemplateActionTranslationKeys.modal;

type ConsentTemplateFillButtonProps = TestableComponentProps & {
   readonly visitId: number;
   readonly printTemplateId: number | undefined;
   readonly printTemplateName: string;
   readonly onDocumentTemplateOpen: VoidFunction;
};

export const ConsentTemplateFillButton = (props: ConsentTemplateFillButtonProps): ReactElement => {
   const push = useHistoryPushWithBackAction(false);

   const goToDocumentTemplate = useCallback<VoidFunction>(() => {
      push(
         visitPaths.getConsentTemplatePath({
            params: { visitId: props.visitId, printTemplateId: props.printTemplateId },
         }),
         {
            label: visitTranslationKeys.goBackToVisit,
         }
      );
      props.onDocumentTemplateOpen();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [props.printTemplateId, props.visitId, push, props.onDocumentTemplateOpen]);

   return (
      <PrintTemplateClickRegisterAction>
         {({ registerClick }) => (
            <Button
               type={'button'}
               testId={props.testId}
               label={t.form.table.options.fill.label}
               variant={ButtonVariant.SECONDARY}
               compact
               onClick={() => {
                  if (props.printTemplateId !== undefined) {
                     registerClick({
                        printTemplateId: props.printTemplateId,
                        printTemplateName: props.printTemplateName,
                     });
                  }
                  goToDocumentTemplate();
               }}
            />
         )}
      </PrintTemplateClickRegisterAction>
   );
};
